"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function AlertImage() {
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "52px",
    height: "45px",
    viewBox: "0 0 52 45",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, "73843F5C-F4AF-4E05-8FDF-9DF850B52E88"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "\uD83D\uDCD0-Design-Specs---Smaller-Titles",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "single-unsupported-account-mobile",
    transform: "translate(-162.000000, -142.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-3",
    transform: "translate(16.000000, 142.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Alert-Blue",
    transform: "translate(146.000000, 0.000000)"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle",
    fill: "#EA4224",
    x: "8.5",
    y: "40.3",
    width: "8.5",
    height: "4.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle",
    fill: "#113B5E",
    x: "23.6",
    y: "20.4",
    width: "4.5",
    height: "13.4"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Path",
    fill: "#113B5E",
    points: "51.7 44.8 25.9 44.8 25.9 40.3 43.9 40.3 25.9 9 7.8 40.3 8.5 40.3 8.5 44.8 0 44.8 25.9 0"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle",
    fill: "#82CDE5",
    x: "23.6",
    y: "37.7",
    width: "4.5",
    height: "7.1"
  })))))));
}
var _default = AlertImage;
exports["default"] = _default;
